import React, { useEffect, useState } from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ECharts from 'echarts-for-react';
const moment=require('moment-jalaali');







const EchartGauge = ({stat,statHum,label}) => {



  useEffect(()=>{
    setOptions({
        series: [
          {
            type: 'gauge',
            center: ['50%', '60%'],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: label==='دما'?60:100,
            splitNumber: 10,
            itemStyle: {
              color: label==='دما'?'#FFAB91':'skyBlue',
            },
            progress: {
              show: true,
              width: 30
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            axisTick: {
              distance: -45,
              splitNumber: 5,
              lineStyle: {
                width: 2,
                color: '#999'
              }
            },
            splitLine: {
              distance: -52,
              length: 14,
              lineStyle: {
                width: 3,
                color: '#999'
              }
            },
            axisLabel: {
              distance: 5,
              color: label==='دما'?'red':'blue',
              fontSize: 11
            },
            anchor: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 20,
              borderRadius: 8,
              offsetCenter: [0, '-15%'],
              fontSize: 11.5,
              formatter:  label==='دما'?'° {value} میانگین دما':'% {value} میانگین رطوبت ',
              color: 'inherit'
            },
            data: [
              {
                value: label==='دما'?(stat?stat:0):(statHum?statHum:0)
              }
            ]
          },
          {
            type: 'gauge',
            center: ['50%', '60%'],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            itemStyle: {
              color: label==='دما'?'#FD7347':'blue',
            },
            progress: {
              show: true,
              width: 8
            },
            pointer: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              show: false
            },
            data: [
              {
                value: label==='دما'?(stat?stat:0):0
              }
            ]
          }
        ]
      })
  },[stat,statHum])


  const [options, setOptions] = useState({
    
        series: [
          {
            type: 'gauge',
            center: ['50%', '60%'],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            splitNumber: 5,
            itemStyle: {
              color: '#FFAB91'
            },
            progress: {
              show: true,
              width: 30
            },
            pointer: {
              show: false
            },
            axisLine: {
              lineStyle: {
                width: 30
              }
            },
            axisTick: {
              distance: -45,
              splitNumber: 6,
              lineStyle: {
                width: 2,
                color: '#999'
              }
            },
            splitLine: {
              distance: -52,
              length: 14,
              lineStyle: {
                width: 3,
                color: '#999'
              }
            },
            axisLabel: {
              distance: -1,
              color: '#999',
              fontSize: 11
            },
            anchor: {
              show: false
            },
            title: {
              show: false
            },
            detail: {
              valueAnimation: true,
              width: '60%',
              lineHeight: 20,
              borderRadius: 8,
              offsetCenter: [0, '-15%'],
              fontSize: 11,
              
              formatter: '° {value} درجه',
              color: 'inherit'
            },
            data: [
              {
                value: 0
              }
            ]
          },
          {
            type: 'gauge',
            center: ['50%', '60%'],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 60,
            itemStyle: {
              color: 'green'
            },
            progress: {
              show: true,
              width: 8
            },
            pointer: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: false
            },
            detail: {
              show: false
            },
            data: [
              {
                value: 0
              }
            ]
          }
        ]
      
	});	

	return (
    <ECharts
    
			option={options}
      opts={{ renderer: 'svg', width: '250px', height: '225px'}}
    />
  );
}
export default EchartGauge